import React from "react";
import { Icon, IconProps } from "../Icon";
/**
 * @group Icons
 */
export function _60fpsSelectIcon(props: IconProps) {
    return <Icon {...props} iconKey={"60fps_select"}/>
}
